import qs from "querystring";
import React from "react";
import _ from "lodash";

import World from "../../world";
import ChangePasswordForm from "./View";

export interface Props {
    world: World;
}

export interface State {
    email: string;
    password: string;
    secret: string;
    is_pending: boolean;
    error?: string;
}

export default class ChangePasswordFormController extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const query = qs.parse(location.search.substring(1));
        // TODO validate email and password
        // TODO pull state from url and clean the url (currently infinite loop)

        this.state = {
            email: _.isArray(query.email) ? _.first(query.email) : query.email,
            password: "",
            secret: _.isArray(query.rt) ? _.first(query.rt) : query.rt,
            is_pending: false,
        };
    }

    public handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        switch (e.currentTarget.name) {
        case "password":
            this.setState({
                password: e.currentTarget.value,
            });
            break;
        }
    }

    public handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.setState({
            is_pending: true,
        });
        const err = await this.props.world.changePassword({
            email: this.state.email,
            password: this.state.password,
            secret: this.state.secret,
        });
        if (err) {
            this.setState({
                error: err.message,
                is_pending: false,
            });
            return;
        }
        this.setState({
            is_pending: false,
        });
        // TODO router when functional
        window.location.href = "/dashboard";
    }

    render() {
        const props = {
            onChange: this.handleChange,
            onSubmit: this.handleSubmit,
            is_pending: this.state.is_pending,
            error: this.state.error,
        };

        return (
            <ChangePasswordForm {...props} />
        );
    }
}
